import { render, staticRenderFns } from "./FaqCic.vue?vue&type=template&id=b1c67ce0&scoped=true"
import script from "./FaqCic.vue?vue&type=script&lang=js"
export * from "./FaqCic.vue?vue&type=script&lang=js"
import style0 from "./FaqCic.vue?vue&type=style&index=0&id=b1c67ce0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c67ce0",
  null
  
)

export default component.exports